import { render } from "./AddWorkerToCompanyAdmin.vue?vue&type=template&id=6e07c300&scoped=true"
import script from "./AddWorkerToCompanyAdmin.vue?vue&type=script&lang=js"
export * from "./AddWorkerToCompanyAdmin.vue?vue&type=script&lang=js"

import "./AddWorkerToCompanyAdmin.vue?vue&type=style&index=0&id=6e07c300&scoped=true&lang=scss"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e07c300"]])

export default __exports__